<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      {{ order.number }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      {{ dateCreated }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <a role="button" class="underline" @click.prevent="showContact">
        {{ contact.firstName }} {{ contact.lastName }}
      </a>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ order.lineItemsSumQuantity }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ paymentMethod }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm">
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
        :class="statusStyle"
      >
        {{ order.status }}
      </span>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ shippingTotal }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ total }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 tabular-nums text-right">
      {{ lastSentThirdPartyServiceName }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-right text-sm font-medium">
      <OrderListItemActions
        :account-id="$route.params.accountId"
        :order="order"
        :softone-api-services="softoneApiServices"
      />
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import numbro from '@/utils/numbro';
import OrderListItemActions from './order-list-item-actions.vue';

export default {
  components: {
    OrderListItemActions,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    softoneApiServices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.order.contact];
    },
    dateCreated() {
      return moment(this.order.dateCreated).format('ddd D MMM Y');
    },
    shippingTotal() {
      return numbro(this.order.shippingTotal).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    total() {
      return numbro(this.order.total).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    statusStyle() {
      const styleByStatus = {
        processing: 'bg-blue-100 text-blue-800',
        cancelled: 'bg-red-100 text-red-800',
        completed: 'bg-green-100 text-green-800',
        default: 'bg-gray-100 text-gray-800',
      };

      return styleByStatus[this.order.status] || styleByStatus.default;
    },
    thirdPartyServiceDocuments() {
      return this.order?.thirdPartyServiceDocuments
        .map((id) => this.$store.state.entities.thirdPartyServiceDocuments.byId[id])
        .filter(Boolean);
    },
    woocommerceThirdPartyServiceDocuments() {
      return (
        this.thirdPartyServiceDocuments.find((document) => {
          const thirdPartyService =
            this.$store.state.entities.thirdPartyServices.byId[document.thirdPartyServiceId];

          if (!thirdPartyService) {
            return false;
          }

          return thirdPartyService.service === 'woocommerce';
        }) || null
      );
    },
    paymentMethod() {
      const paymentMethods = {
        cod: 'Cash on Delivery',
        cc: 'Credit Card',
        bacs: 'Direct Bank Transfer',
        cash: 'Cash',
      };

      return (
        this.woocommerceThirdPartyServiceDocuments?.paymentMethodTitle ||
        paymentMethods?.[this.order.paymentMethod] ||
        'Unknown'
      );
    },
    lastSent() {
      const count = this.thirdPartyServiceDocuments.length;
      if (count === 0) {
        return null;
      }

      const [first] = this.thirdPartyServiceDocuments
        .slice()
        .sort((a, b) => (moment(a.created).isBefore(moment(b.created)) ? 1 : -1));

      return first;
    },
    lastSentThirdPartyService() {
      if (!this.lastSent) {
        return null;
      }

      return (
        this.$store.state.entities.thirdPartyServices.byId[this.lastSent.thirdPartyServiceId] ||
        null
      );
    },
    lastSentThirdPartyServiceName() {
      return this.lastSentThirdPartyService?.config?.name || 'no name';
    },
  },
  methods: {
    showContact() {
      this.$modal.show({
        component: 'ContactModal',
        props: {
          contactId: this.contact.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
